export const en = {
	idStrings: {
		// menu *******************************************************************
		// file **********************************************
		file: "File",
		"load-sparql": "Load from SPARQL endpoint",
		"load-session": "Load session",
		"load-view": "Load Partial Graph",
		"load-layout": "Load Layout of Partial Graph",
		"save-session": "Save Session",
		"save-snik-graph": "Save complete graph as Cytoscape File",
		"new-view": "Open New Partial Graph",
		"save-view": "Save Current Partial Graph",
		"save-layout": "Save Layout of Current Partial Graph",
		"recalculate-layout-replace": "Recalculate Layout and Replace in Browser Cache",
		"save-image-png-visible-region": "Save PNG Image of Visible Region",
		"save-image-png-complete-partial-graph": "Save PNG Image of Complete Partial Graph",
		"save-image-png-visible-region-high-res": "Save PNG Image of Visible Region (high res)",
		"save-image-png-complete-partial-graph-high-res": "Save PNG Image of Complete Partial Graph (high res)",
		"save-image-svg-visible-region": "Save SVG Image of Visible Region",
		"save-image-svg-complete-partial-graph": "Save SVG Image of Complete Partial Graph",
		// filter ********************************************
		filter: "Filter",
		meta: "meta",
		bb: "BB",
		ob: "OB",
		ciox: "CioX",
		he: "HE",
		it: "IT",
		it4it: "IT4IT",
		bb2: "BB2",
		role: "Role",
		function: "Function",
		entitytype: "EntityType",
		"show-classes-with-instances": "Show Classes with Instances",
		"show-classes-without-instances": "Show Classes without Instances",
		subclassof: "subClassOf",
		"non-subclassof": "non-subClassOf",
		"inter-ontology-relations": "Inter-Ontology Relations",
		"intra-ontology-relations": "Intra-Ontology Relations",
		// options********************************************
		options: "Options",
		separateColours: "Separate Colours",
		cumulativeSearch: "Cumulative Search",
		grid: "Show Grid",
		dayMode: "Day Mode",
		coloredEdges: "Colorize Edges by Type",
		showProperty: "Always Show Relation Descriptions",
		devMode: "Developer Mode",
		extMode: "Extended Mode",
		combineMatchMode: "Combine Matches",
		starNewView: "Star in New Partial Graph",
		// layout*********************************************
		layout: "Layout",
		"show-close-matches": "Show Close Matches",
		"recalculate-layout": "Recalculate Layout",
		"tight-layout": "Tight Layout",
		//"custom-layout": "custom layout",
		"compound-layout": "Compound Layout",
		"bb-chapter-search": "BB Chapter Search",
		"ob-chapter-search": "OB Chapter Search",
		"reset-view": "Reset Main Graph",
		"move-match-nearby": "Move Matches Nearby",
		"move-match-on-top": "Move Matches on Top of Each Other",
		"subontology-connectivity": "Subontology Connectivity",
		"change-title": "Change Title of Active Partial Graph",
		// services ******************************************
		services: "Services",
		"sparql-endpoint": "SPARQL Endpoint",
		"rdf-browser": "RDF Browser",
		//"data-quality-evaluation": "Data Quality Evaluation",
		// language ******************************************
		language: "Language",
		english: "English",
		german: "German",
		persian: "Persian",
		// help **********************************************
		help: "Help",
		manual: "Manual",
		tutorial: "Tutorial",
		"layout-help": "Layout Help",
		"developer-doc": "Developer Documentation",
		"youtube-channel": "YouTube Channel",
		troubleshooting: "Troubleshooting",
		contribute: "Contribute",
		"project-homepage": "Project Homepage",
		"meta-model": "Ontology Meta Model",
		about: "About SNIK Graph",
		"bug-report": "Submit a Bug Report",
		"feature-request": "Request new Feature for the Visualization",
		"feedback-ontology": "Submit Feedback about the Ontology",
		// other *********************************************
		"deselect-all": "Deselect All",
		"search-field": "Search Field",
		"base-mode": "Basic Menu Items",
		"context-menu": "Context Menu",
		"incoming-star": "Incoming Star",
		"outgoing-star": "Outgoing Star",
		"combine-close-matches": "Combine Close Matches",
		"class-use": "Class Use",
		"show-instances": "Show Instances of this Class",
	},
	messageStrings: {
		"no-search-results-for": "No Search Results for",
		"ontology-issue-warning":
			"Please note that this is only for feedback about the ontology! Please check if there is already an issue for your problem. If not, we will consider your feedback ASAP.",
	},
	contextMenuStrings: {
		"edge-edit": "Edit or Report",
		"edge-hide": "Hide",
		"edge-description": "Description (if existing)",
		"edge-confirm-link": "Confirm Link",
		"edge-dev": "Developer",
		"remove-permanently": "Remove Permanently",
		debug: "Debug",
		compound: "Compound",
		open: "Open",
		"move-match-on-top": "Move Matches on Top of Each Other",
		"move-match-nearby": "Move Matches Nearby",
		"compound-star": "Star",
		"compound-incoming-star": "Incoming Star",
		"compound-outgoing-star": "Outgoing Star",
		"compound-path-source": "Set Path as Source",
		edit: "Edit or Report",
		"class-use": "Class Use",
		hide: "Hide",
		description: "Description (if existing)",
		"set-path-source": "Set Path as Source",
		star: "Star",
		"incoming-star": "Incoming Star",
		"outgoing-star": "Outgoing Star",
		path: "Path",
		spiderworm: "Spiderworm",
		dev: "Developer",
		ext: "Extended",
		doublestar: "Doublestar",
		starpath: "Starpath",
		circlestar: "Circle Star",
		lodlive: "LodLive",
		"move-selected": "Move Selected",
		"close-match": "Close Match",
		"show-instances": "Show Instances",
	},
};
